import { render, staticRenderFns } from "./shoppingCart.vue?vue&type=template&id=f35321b6&scoped=true&"
import script from "./shoppingCart.vue?vue&type=script&lang=js&"
export * from "./shoppingCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35321b6",
  null
  
)

export default component.exports